module.exports = __webpack_public_path__ + "img/inApproval2-icon.0e3f67fb.png";